module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "subtitle",
    attrs: {
      "id": "title"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('strong', [_vm._v("BUILDING A LEADERSHIP CULTURE")])])])]), _vm._v(" "), _c('h1', {
    staticClass: "h1"
  }, [_vm._v("LEADERS"), _c('br'), _vm._v("MADE"), _c('br'), _vm._v("HERE")]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('strong', [_vm._v("MARK MILLER")])])]), _vm._v(" "), _c('p', {
    staticClass: "edit"
  }, [_vm._v("Bestselling author of "), _c('em', [_vm._v("Chess Not Checkers")]), _vm._v(" and "), _c('em', [_vm._v("The Heart of Leadership")])]), _vm._v(" "), _c('p', {
    staticClass: "pub"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/pub.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-943463b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/title.vue
// module id = 66
// module chunks = 0